import axios from 'axios'
import API_URL from '@/router/api'
import * as types from './mutation-types'

export const findManyTeacherRequest = (ctx, params) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.teacherRequest.findMany

        axios.get(url, { params }).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

export const updateTeacherRequest = (ctx, { id, form }) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.teacherRequest.update.replace(/__id__/, id)

        axios.patch(url, form)
            .then(res => {
                getTotalTeacherRequest(ctx)
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const assignUserToSchool = (ctx, payload) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.teacherRequest.assignUserToSchool.replace(/__id__/, payload.school_id)

        delete payload.school_id

        axios.post(url, payload)
            .then(res => {
                getTotalTeacherRequest(ctx)
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const getTotalTeacherRequest = (ctx, query = {}) => {
    return new Promise((resolve, reject) => {

        axios.get(API_URL.teacherRequest.getTotalTeacherRequest, { params: query })
            .then(res => {
                ctx.commit(types.SET_TEACHER_REQUEST, res.data.data.total)
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
